import React, { Component } from 'react';
import {
  Text,
  View,
  Platform,
  StyleSheet,
} from 'react-native';

import {
  Heading,
  HeadingTypes,
} from '../../components';
import { defaultScale } from '../../utils/scaling';


import { ChangeableAvatar } from '../../components/ChangeableAvatar';
import Theme from '../../theme';

const styles = StyleSheet.create({
  profileContainer: {
    padding: defaultScale(15),
    paddingTop: 0,
    alignSelf: 'center',
    backgroundColor: Theme.WHITE
  },
  headerName: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
  },
  locationDisplay: {
    ...Theme.textStyle.small,
    color: Theme.GREY,
    textAlign: 'center',
  },
  modalContainer: {
    flex: 1,
    backgroundColor: Platform.OS !== 'web' && 'rgba(0, 0, 0, 0.5)',
  },
  innerContainer: {
    margin: defaultScale(15),
    padding: defaultScale(10),
    marginTop: defaultScale(70),
    borderRadius: defaultScale(10),
    paddingBottom: defaultScale(30),
    backgroundColor: Theme.WHITE,
  },
  modalText: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
    color: Theme.CHARCOAL,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});

class SettingsProfile extends Component {
  render() {
    const { userProfile, navigation } = this.props;

    let displayState = '';
    if (userProfile.state) {
      displayState = `${userProfile.state},`;
    }
    return (
      <View style={styles.profileContainer}>
        <ChangeableAvatar size={defaultScale(120)} userProfile={userProfile} navigation={navigation} />
        <Heading
          style={styles.headerName}
          title={userProfile.fullname}
          headingType={HeadingTypes.HEADING_ONE}
        />
      </View>
    );
  }
}

export default SettingsProfile;
